import React from 'react';
import PropTypes from 'prop-types';
import { Visible } from '@tfecom-thermofisher/react-komodo-design';

import DoubleSideLayout from 'src/components/DoubleSideLayout';
import {
  ALIQUOTS_CHECKED,
  NORMALIZATION,
  NORMALIZATION_OPTIONS,
} from 'src/constants/forms';
import Remainders from 'src/components/Remainders';
import SummaryCard from 'src/components/OligoDNA/components/SummaryCard';

import { Normalization, Aliquots } from './components';

const NormalizationAliquotsComponent = ({
  formData = {},
  onChangeData,
  plateSizeDetails,
  showAliquotsCommonErr,
  maxValue
}) => {
  const selectedNormalization = formData[NORMALIZATION]?.value;
  const aliquotsVisible =
    selectedNormalization === NORMALIZATION_OPTIONS.VOLUME ||
    selectedNormalization === NORMALIZATION_OPTIONS.CONCENTRATION;
  const remaindersVisible =
    formData[ALIQUOTS_CHECKED]?.value &&
    (selectedNormalization === NORMALIZATION_OPTIONS.VOLUME ||
      selectedNormalization === NORMALIZATION_OPTIONS.CONCENTRATION);

  const renderedComponent = (
    <div>
      <Normalization {...{ formData, onChangeData, plateSizeDetails }} />
      <Visible when={aliquotsVisible}>
        <Aliquots {...{ formData, onChangeData, showAliquotsCommonErr, maxValue }} />
      </Visible>
      <Visible when={remaindersVisible}>
        <Remainders />
      </Visible>
    </div>
  );

  return (
    <DoubleSideLayout
      leftContent={renderedComponent}
      rightContent={<SummaryCard />}
    />
  );
};

NormalizationAliquotsComponent.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  plateSizeDetails: PropTypes.object,
  showAliquotsCommonErr: PropTypes.bool,
  maxValue: PropTypes.any
};

export default NormalizationAliquotsComponent;
